<template>
    <AuthLayout v-bind="customerSharedData.getAuthLayoutProps()">
        <div v-if="googleSocialLoginEnabled">
            <div class="mt-6 space-y-4">
                <GoogleSocialAuthButton
                    :url="urlFactory.makeCustomerGoogleOAuthRedirectUrl()"
                >
                    Sign in with Google
                </GoogleSocialAuthButton>
            </div>

            <div class="relative mt-4">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
                <div
                    class="relative flex justify-center text-sm font-medium leading-6"
                >
                    <span class="bg-white px-6 text-gray-900">Or</span>
                </div>
            </div>
        </div>

        <ApiForm
            method="POST"
            :url="urlFactory.makeCustomerLoginUrl()"
            ref="apiFormRef"
        >
            <FormControl
                label="Email"
                required
                :error="
                    apiFormRef?.response?.getValidationError(
                        RequestBodyKeyEnum.Customer_Auth_Login_Email,
                    )
                "
            >
                <TextInput
                    type="email"
                    :name="RequestBodyKeyEnum.Customer_Auth_Login_Email"
                    required
                />
            </FormControl>
            <FormControl
                label="Password"
                required
            >
                <TextInput
                    type="password"
                    :name="RequestBodyKeyEnum.Customer_Auth_Login_Password"
                    required
                />
            </FormControl>
            <Button
                @click="apiFormRef?.submit()"
                :loading="apiFormRef?.loading.valueOf()"
                iconName="arrow-right"
                :iconRight="true"
                class="w-full mt-2"
            >
                Login
            </Button>
            <div class="flex flex-col mt-4 space-y-1">
                <div class="text-sm leading-6">
                    <a
                        :href="urlFactory.makeCustomerPasswordResetUrl()"
                        class="font-semibold text-primary hover:text-primary-shade"
                    >
                        Forgot or don't have a password?
                    </a>
                </div>
            </div>
        </ApiForm>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import Button from '@/Shared/Component/Button.vue'
    import AuthLayout from '@/Shared/Layout/Customer/Auth/AuthLayout.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Customer from '@/App/Customer/Entity/Customer'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import GoogleSocialAuthButton from '@/App/User/Component/GoogleSocialAuthButton.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    interface ShowCustomerLoginProps {
        customerSharedDataData: CustomerSharedData
        googleSocialLoginEnabled: boolean
        turnstileEnabled: boolean
        turnstileSiteKey: string
    }

    const props = defineProps<ShowCustomerLoginProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
